import { Link } from "react-router-dom";
import { MapPin, Bed, Bath, Maximize2 } from "lucide-react";

export default function PropertyCard({ p }) {
  return (
    <Link
      to={`/properties/${p.id}`}
      data-testid={`property-card-${p.id}`}
      className="prop-card group block bg-white border border-brand-gold/15 overflow-hidden"
    >
      <div className="img-wrap relative aspect-[4/3] overflow-hidden bg-brand-cream">
        <img src={p.images?.[0] || "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200"} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
        <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
          {(p.badges || []).slice(0, 2).map((b) => (
            <span key={b} className="bg-brand-gold text-brand-navy text-[10px] font-bold px-2 py-1 uppercase tracking-widest">{b}</span>
          ))}
        </div>
        <div className="absolute top-3 right-3 bg-brand-navy/90 text-white text-[10px] font-bold px-2 py-1 uppercase tracking-widest">
          For {p.purpose}
        </div>
      </div>

      <div className="p-5">
        <div className="text-brand-gold font-serif text-2xl leading-none">{p.price_label || `₹ ${p.price.toLocaleString('en-IN')}`}</div>
        <h3 className="mt-2 font-serif text-lg text-brand-navy leading-snug group-hover:text-brand-gold transition-colors">{p.title}</h3>
        <div className="mt-1 flex items-center gap-1 text-xs text-brand-charcoal/70">
          <MapPin size={12} className="text-brand-gold" /> {p.location || `${p.city}, ${p.state}`}
        </div>
        <div className="mt-4 flex items-center gap-4 text-xs text-brand-charcoal/80 border-t border-brand-gold/15 pt-3">
          {p.bhk ? <span className="flex items-center gap-1"><Bed size={12} className="text-brand-gold" /> {p.bhk} BHK</span> : null}
          {p.bathrooms ? <span className="flex items-center gap-1"><Bath size={12} className="text-brand-gold" /> {p.bathrooms}</span> : null}
          <span className="flex items-center gap-1 ml-auto"><Maximize2 size={12} className="text-brand-gold" /> {p.area} {p.area_unit}</span>
        </div>
      </div>
    </Link>
  );
}
